import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { SettingsWidget } from '@/widgets/settings-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.keys': z.array(z.string()).optional(),
  'filter.modules': z.array(z.string()).optional(),
  'filter.scopes': z.array(z.string()).optional(),
  'filter.types': z.array(z.string()).optional(),
  'filter.isActive': z.boolean().optional(),
})

export const Route = createFileRoute('/_auth/administration/settings')({
  staticData: {
    meta: {
      title: 'Настраиваемые параметры',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.SETTINGS}>
      <PageWrapper title={t('Настраиваемые параметры')}>
        <SettingsWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
